import { iconConfig } from "./config.icons";
// const gw_sw_graphic = require("./assets/gw_sw_interaction.png");
export const initialLayerState = {
  // -------------------------------------
  // NGWOS Project Sites
  // -------------------------------------
  "ngwos-project-sites": {
    id: "ngwos-project-sites",
    name: "NGWOS Project Sites",
    data: "sites",
    showLayer: true,
    layerType: "icon",
    colorValue: "site_status",
    activeFilters: {},
    iconProperty: "site_type",
    iconMap: {
      AT: iconConfig["diamond"],
      GW: iconConfig["circle"],
      LA: iconConfig["up-arrow"],
      LK: iconConfig["up-arrow"],
      SP: iconConfig["circle"],
      ST: iconConfig["up-arrow"],
      "ST-DCH": iconConfig["up-arrow"],
      SW: iconConfig["up-arrow"],
    },
    properties: [
      {
        id: "site_type",
        label: "Site Type",
        filterable: true,
        colorable: false,
        description: "Primary Site Type",
        groupId: "site-attributes",
      },
      {
        id: "site_status",
        label: "Site Status",
        filterable: true,
        colorable: true,
        description: "Site Status",
        groupId: "site-attributes",
        colorMap: {
          Active: { hex: "#4e79a7", opacity: 0.8 },
          Inactive: { hex: "#e15759", opacity: 0.8 },
        },
      },
    ],
    propertyGroups: {},
    tooltipFields: [],
  },
  // -------------------------------------
  // nwdi api sites
  // -------------------------------------
  "non-ngwos-project-sites": {
    id: "non-ngwos-project-sites",
    name: "Non-NGWOS Project Sites",
    data: "nonNgwosSites",
    showLayer: false,
    layerType: "icon",
    colorValue: "ngwos_basin",
    iconProperty: "site_cat_1",
    iconMap: {
      "Atmospheric": iconConfig["diamond"],
      "Surface Water": iconConfig["up-arrow"],
      "Groundwater": iconConfig["circle"],
    },
    properties: [
      {
        id: "site_cat_1",
        label: "Site Type",
        filterable: true,
        description: "Primary Site Type",
        groupId: "site-attributes",
      },
      {
        id: "ngwos_basin",
        label: "NGWOS Basin",
        filterable: true,
        colorable: true,
        description: "NGWOS Basin",
        groupId: "site-attributes",
        colorMap: {
          "Upper Colorado River Basin": { hex: "#DDAA33", opacity: 0.8 }, // A warm yellowish color
          "Illinois River Basin": { hex: "#A95B8D", opacity: 0.8 }, // A muted purple color
          "Delaware River Basin": { hex: "#665191", opacity: 0.8 },
          "Willamette River Basin": { hex: "#00621C", opacity: 0.8 },
          "Trinity-San Jacinto Basin": { hex: "#f28e2b", opacity: 0.8 },
        },
      },
      // {
      //   id: "qa_status",
      //   label: "QA Status",
      //   filterable: true,
      //   colorable: true,
      //   description: "QA Status",
      //   groupId: "site-attributes",
      //   colorMap: {
      //     Approved: { hex: "#4e79a7", opacity: 0.8 },
      //     Provisional: { hex: "#e15759", opacity: 0.8 },
      //     "Working/In-Review": { hex: "#665191", opacity: 0.8 },
      //   },
      // },
      // {
      //   id: "active_planned",
      //   label: "Active or Planned",
      //   filterable: true,
      //   colorable: true,
      //   description: "Site transmitting real-time water-quality data",
      //   groupId: "site-attributes",
      //   colorMap: {
      //     Active: { hex: "#4e79a7", opacity: 0.8 },
      //     Planned: { hex: "#e15759", opacity: 0.8 },
      //   },
      // },
      // {
      //   id: "gw_levels_dtw",
      //   label: "Groundwater Level",
      //   filterable: true,
      //   colorable: true,
      //   description:
      //     "Depths to water (dtw) are feet below land surface datum. Depths to water are not available for stations measuring water levels relative to other measurement datums. Data source: NWIS, CWIS",
      //   groupId: "realtime-water-data",
      //   colorMap: {
      //     "0 - 50 feet": { hex: "#fb4", opacity: 0.8 },
      //     "50 - 100 feet": { hex: "#f83", opacity: 0.8 },
      //     "100 - 150 feet": { hex: "#f42", opacity: 0.8 },
      //     "150 - 200 feet": { hex: "#e11", opacity: 0.8 },
      //     "200 - 250 feet": { hex: "#b02", opacity: 0.8 },
      //     ">250 feet": { hex: "#802", opacity: 0.8 },
      //     "No Data": { hex: "#808080", opacity: 0.2 },
      //   },
      // },
      // {
      //   id: "gw_inc_dec",
      //   label: "Groundwater Increasing/Decreasing",
      //   filterable: true,
      //   colorable: true,
      //   description:
      //     "Depths to water (dtw) are feet below land surface datum. Depths to water are not available for stations measuring water levels relative to other measurement datums. Data source: NWIS, CWIS",
      //   groupId: "realtime-water-data",
      //   colorMap: {
      //     Increasing: { hex: "#4e79a7", opacity: 0.8 },
      //     Decreasing: { hex: "#e15759", opacity: 0.8 },
      //     Steady: { hex: "#f28e2b", opacity: 0.8 },
      //     "No Data": { hex: "#808080", opacity: 0.8 },
      //   },
      // },
      {
        id: "sw_streamflow_statcode",
        label: "Surface Water Status",
        filterable: true,
        colorable: true,
        description:
          "The National Weather Service (NWS) uses selected USGS stream stations for river forecasts. These stations have flood stages assigned and maintained by the NWS. NWS river forecasts can be accessed at https://water.weather.gov/ahps/forecasts.php. Data source: NWS",
        groupId: "realtime-water-data",
        colorMap: {
          "All Time Low (0 percentile)": { hex: "#f40800", opacity: 0.8 },
          "Much Below Normal (<10 percentile)": {
            hex: "#b92024",
            opacity: 0.8,
          },
          "Below Normal (10-24 percentile)": { hex: "#ff9d00", opacity: 0.8 },
          "Normal (25-75 percentile)": { hex: "#00ff00", opacity: 0.8 },
          "Above Normal (76-90 percentile)": { hex: "#39ddd2", opacity: 0.8 },
          "Much Above Normal (>90 percentile)": {
            hex: "#0000f4",
            opacity: 0.8,
          },
          "All Time High (100 percentile)": { hex: "#000", opacity: 0.8 },
          ICE: { hex: "#999", opacity: 1 },
          EQP: { hex: "#999", opacity: 1 },
          SSN: { hex: "#999", opacity: 1 },
          DRY: { hex: "#999", opacity: 1 },
          DIS: { hex: "#999", opacity: 1 },
          "***": { hex: "#999", opacity: 1 },
          MNT: { hex: "#999", opacity: 1 },
          ZFL: { hex: "#999", opacity: 1 },
          FLD: { hex: "#999", opacity: 1 },
          RAT: { hex: "#999", opacity: 1 },
          BKW: { hex: "#999", opacity: 1 },
        },
      },
      {
        id: "sw_streamflow_category",
        label: "Streamflow",
        filterable: true,
        colorable: true,
        description:
          "Streamflow (cfs). Not all measurement flags shown. Data source: NWIS, CWIS",
        groupId: "realtime-water-data",
        colorMap: {
          "No Data": { hex: "#808080", opacity: 0.8 },
          "0 cfs (Not Flowing)": { hex: "#fff", opacity: 0.8 },
          "0 - 10 cfs": { hex: "#ceb", opacity: 0.8 },
          "10 - 100 cfs": { hex: "#7cb", opacity: 0.8 },
          "100 - 1000 cfs": { hex: "#4bc", opacity: 0.8 },
          "1000 - 10,000 cfs": { hex: "#19c", opacity: 0.8 },
          "10,000 - 100,000 cfs": { hex: "#25a", opacity: 0.8 },
          ">100,000 cfs": { hex: "#239", opacity: 0.8 },
          ICE: { hex: "#999", opacity: 0.8 },
          EQP: { hex: "#999", opacity: 0.8 },
          SSN: { hex: "#999", opacity: 0.8 },
          DRY: { hex: "#999", opacity: 0.8 },
          DIS: { hex: "#999", opacity: 0.8 },
          "***": { hex: "#999", opacity: 0.8 },
          MNT: { hex: "#999", opacity: 0.8 },
          ZFL: { hex: "#999", opacity: 0.8 },
          RAT: { hex: "#999", opacity: 0.8 },
          BKW: { hex: "#999", opacity: 0.8 },
        },
      },
      {
        id: "sw_inc_dec",
        label: "Surface Water Increasing/Decreasing",
        filterable: true,
        colorable: true,
        description:
          "Rate of change is computed by subtracting the two most recent values divided by the elapsed time and converting to feet per hour. Most stations collect data at 15 minute intervals. Data source: NWIS, CWIS",
        groupId: "realtime-water-data",
        colorMap: {
          Increasing: { hex: "#4e79a7", opacity: 0.8 },
          Decreasing: { hex: "#e15759", opacity: 0.8 },
          Steady: { hex: "#f28e2b", opacity: 0.8 },
          "No Data": { hex: "#808080", opacity: 0.8 },
        },
      },
      {
        id: "sw_nws_floodstage",
        label: "Surface Water NWS Flood Stage",
        filterable: true,
        colorable: true,
        description:
          "The National Weather Service (NWS) uses selected USGS stream stations for river forecasts. These stations have flood stages assigned and maintained by the NWS. NWS river forecasts can be accessed at https://water.weather.gov/ahps/forecasts.php. Data source: NWS",
        groupId: "realtime-water-data",
        colorMap: {
          "Not Flooding": { hex: "#00ff00", opacity: 0.8 },
          "In Action Stage": { hex: "#ffff00", opacity: 0.8 },
          "In Minor Flood Stage": { hex: "#ff9900", opacity: 0.8 },
          "In Moderate Flood Stage": { hex: "#ff0000", opacity: 0.8 },
          "In Major Flood Stage": { hex: "#cc33ff", opacity: 0.8 },
          "No Data": { hex: "#808080", opacity: 0.2 },
        },
      },
    ],
    propertyGroups: {
      "site-attributes": {
        label: "Site Attributes",
      },
      "realtime-water-data": {
        label: "Real-Time Water Data",
      },
    },
    showPlot: true,
    siteNumberField: "site_number",
    primarySiteCategoryField: "site_cat_1",
    // type property can be one of:
    //  title
    //  text-header: below title, above text-highlight
    //  text-highlight: emphasizes fields with instantaneous/changing values
    //  text-footer: below text-highlight
    //  link: default last item. for links, dynamicLabel is another field_name (e.g. site_name)
    tooltipFields: [
      {
        fieldName: "site_number",
        label: "Monitoring location",
        type: "text-header",
        section: "main",
      },
      {
        fieldName: "ngwos_basin",
        label: "NGWOS Basin",
        type: "text-header",
        section: "main",
      },
      {
        fieldName: "site_name",
        label: "Station Name",
        type: "title",
        section: "main",
      },
      {
        fieldName: "site_number",
        label: "NWIS",
        type: "link",
        urlTemplate:
          "https://waterdata.usgs.gov/monitoring-location/{site_number}",
        templateFields: ["site_number"],
        section: "main",
      },
      {
        label: "Google Earth",
        type: "link",
        urlTemplate:
          "https://earth.google.com/web/@{latitude},{longitude},4.1972381a,3204.7080705d",
        templateFields: ["latitude", "longitude"],
        section: "main",
      },
    ],
  },
};
